export const STRANDS_BY_GRADE = {
  'Grade 11': [
    { code: 'ASSH', label: 'Arts, Social Sciences, and Humanities (ASSH)' },
    { code: 'BAE', label: 'Business and Entrepreneurship (BAE)' },
    { code: 'HAT', label: 'Hospitality and Tourism (HAT)' },
    { code: 'ICT', label: 'Information and Communications Technology (ICT)' },
  ],
  'Grade 12': [
    { code: 'ABM', label: 'Accountancy, Business, and Management (ABM)' },
    { code: 'HUMSS', label: 'Humanities and Social Sciences (HUMSS)' },
    { code: 'HE', label: 'Home Economics (HE)' },
    { code: 'ICT', label: 'Information and Communications Technology (ICT)' },
  ],
};

// Track and Strand only apply to senior high (students.grade_level '11'/'12',
// stored as a bare number — see gradeLevels.js).
export function getStrandsForGradeLevel(gradeLevel) {
  return STRANDS_BY_GRADE[`Grade ${gradeLevel}`] ?? [];
}

export function getStrandLabel(code) {
  if (!code) return '';
  for (const strands of Object.values(STRANDS_BY_GRADE)) {
    const match = strands.find((s) => s.code === code);
    if (match) return match.label;
  }
  return code;
}

// ICT and HE are this school's vocational (NC-based) strands; every other
// strand runs under the Academic track.
export function deriveTrackFromStrand(code) {
  if (!code) return null;
  return code === 'ICT' || code === 'HE' ? 'Technical-Vocational Livelihood' : 'Academic';
}
